import React from 'react';
import Link from 'components/link';
import Image from 'next/image';
import Button from 'components/control/button';
import { trackEvent } from 'utils/google-tag-manager';
import styles from './style.module.scss';
import { homepageIds } from 'constants/test-constants';
import { sanitizeTestid } from 'utils/stringSanitization';
import { buildClassName } from 'utils/build-class-name';

interface Props {
  content: {
    image: string;
    title: string;
    copy: string;
    link: string;
  };
  cardEvent: string;
  buttonEvent: string;
  right?: boolean;
}

export default function ContentBlock({ content, cardEvent, buttonEvent, right }: Props) {
  return (
    <div className={buildClassName(styles.component, right && styles.right)} data-testid={sanitizeTestid(content.link)}>
      <Link as={content.link} href={content.link} className={buildClassName(styles.card, right && styles.right)} onClick={() => trackEvent(cardEvent)} testId={homepageIds.contentBlockImage}>
        <div style={{ position: 'relative', width: '100%', height: '100%' }}>
          <Image
            className={styles.image}
            src={content.image}
            alt={content.title}
            fill={true}
            style={{ objectFit: 'cover', objectPosition: content.image.includes('exp-buy') ? 'top' : 'center', backgroundColor: '#f6f6f6' }}
            sizes="(max-width: 480px) 100vw, (max-width: 768px) 80vw, 650px"
            quality={75}
            loading="lazy"
          />
        </div>
      </Link>
      <div className={styles.text}>
        <Link as={content.link} href={content.link} onClick={() => trackEvent(buttonEvent)} testId={homepageIds.contentBlockTitle}>
          <h2>{content.title}</h2>
        </Link>
        <p data-testid={homepageIds.contentBlockParagraph}>{content.copy}</p>
        <Link as={content.link} className={styles['button-container']} href={content.link} testId={homepageIds.contentBlockButton}>
          <Button className={styles.button} label="Learn More" theme="secondary" onClick={() => trackEvent(buttonEvent)} />
        </Link>
      </div>
    </div>
  );
}
